import { defineMessages } from 'react-intl'

export default defineMessages({
  permissionRequiredTitle: {
    id: 'accessForbidden.title',
    defaultMessage: 'Permission required',
  },
  permissionRequiredMessage: {
    id: 'accessForbidden.message',
    defaultMessage: 'You do not have permissions to access this page. Please contact an administrator.',
  },
  permissionRequiredAction: {
    id: 'accessForbidden.action',
    defaultMessage: 'Change organization',
  },
})
